import { render, staticRenderFns } from "./applyModel.vue?vue&type=template&id=04845e78&scoped=true"
import script from "./applyModel.vue?vue&type=script&lang=js"
export * from "./applyModel.vue?vue&type=script&lang=js"
import style0 from "./applyModel.vue?vue&type=style&index=0&id=04845e78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04845e78",
  null
  
)

export default component.exports